import React from 'react';
import DataProjects from '../data/DataProjects';
import '../css/elements/Table.css';

function Table() {
  return (
    <section className="section-projects">
      <table
        className="table-projects"
      >
        <tr>
          <th>Nome do projeto</th>
          <th
            className="hide-320x600"
          >
            Solicitante
          </th>
          <th
            className="hide-320x600"
          >
            Data da entrega
          </th>
          <th
            className="hide-320x600"
          >
            Descrição
          </th>
          <th>Links</th>
        </tr>
        {
          DataProjects.map((project, index) => (
            <tr
              key={ index }
            >
              <td>{ project.name }</td>
              <td
                className="hide-320x600"
              >
                { project.Requester }
              </td>
              <td
                className="hide-320x600"
              >
                { project.date }
              </td>
              <td
                className="hide-320x600"
              >
                { project.description }
              </td>
              <td>
                {
                  project.gitHubLink.length > 0
                  ? (
                    <a
                      href={ project.gitHubLink }
                      target="_blank"
                      rel="noreferrer"
                    >
                    <img
                      src="https://img.icons8.com/ios-glyphs/26/000000/github.png"
                      alt="Flávio's GitHub link"
                    />
                    </a>
                  )
                  : (
                    <div className="tooltip">
                      <img
                        
                        src="https://img.icons8.com/plumpy/26/000000/coming-soon.png"
                        alt="coming soon"
                      />
                      <span className="tooltiptext">Em breve</span>
                    </div>
                  )
                }
                {
                  project.pageLink.length > 0
                  ? (
                    <a
                      href={ project.pageLink }
                      target="_blank"
                      rel="noreferrer"
                    >
                    <img
                      src="https://img.icons8.com/material-rounded/26/000000/project.png"
                      alt="Flávio's project link"
                    />
                    </a>
                  )
                  : (
                    <div className="tooltip">
                      <img
                        
                        src="https://img.icons8.com/plumpy/26/000000/coming-soon.png"
                        alt="coming soon"
                      />
                      <span className="tooltiptext">Em breve</span>
                    </div>
                  )
                }
              </td>
            </tr>
          ))
        }
      </table>
    </section>
  )
}

export default Table
